import { skipToken, useQuery } from '@tanstack/react-query';
import { JiraIntegrationAPI } from '@/lib/api/work-integrations/jira';
import { workIntegrationsQueryKeys } from '@/lib/query-keys/work-integrations';

export const useGetJiraItemLevelMappings = ({
  instanceId,
  enabled = true,
}: {
  instanceId?: string;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: workIntegrationsQueryKeys.jiraItemLevelMappings({
      instanceId,
    }),
    queryFn: instanceId
      ? () =>
          JiraIntegrationAPI.getJiraItemLevelMappings({
            instanceId,
          })
      : skipToken,
    enabled,
  });
};
